export default __webpack_public_path__ + "img/4bc9548476ebfde1c16202d75d9dbbab.png";